<template>
  <PluginItemAction
    id="delete"
    :title="$t('deleteButton', 'Delete')"
    :disabled="state.editMode.value !== 'editing'"
    multiple
    key-code="Delete"
    icon="delete"
    :weight="-80"
    @click="onClick"
  />
</template>

<script setup>
import { useBlokkli, defineBlokkliFeature } from "#imports";
import { PluginItemAction } from "#blokkli/plugins";
const { state, $t, eventBus, dom, runtimeConfig } = useBlokkli();
const { adapter } = defineBlokkliFeature({
  id: "delete",
  icon: "delete",
  label: "Delete",
  requiredAdapterMethods: ["deleteBlocks"],
  description: "Provides an action to delete one or more blocks."
});
function getSelectionAfterDelete(items) {
  if (items.length !== 1) {
    return;
  }
  const uuid = items[0].uuid;
  const field = state.getFieldListForBlock(uuid);
  if (!field) {
    return;
  }
  const index = field.list.findIndex((v) => v.uuid === uuid);
  if (index === -1) {
    return;
  }
  const inList = field.list[index + 1]?.uuid || field.list[index - 1]?.uuid;
  if (inList) {
    return inList;
  }
  if (field.entityType !== runtimeConfig.itemEntityType) {
    return;
  }
  return field.entityUuid;
}
async function onClick(items) {
  const selectedUuidsAfter = getSelectionAfterDelete(items);
  await state.mutateWithLoadingState(
    () => adapter.deleteBlocks(items.map((v) => v.uuid)),
    $t("deleteError", "The block could not be deleted.")
  );
  if (selectedUuidsAfter) {
    eventBus.emit("select", selectedUuidsAfter);
    dom.refreshBlockRect(selectedUuidsAfter);
  } else {
    eventBus.emit("select:unselect");
  }
}
</script>

<script>
export default {
  name: "Delete"
};
</script>
